<div *ngIf="isSet && isActive" class=" card bg-light mb-3 chart-wrapper position-absolute  d-flex shadow align-items-center" 
cdkDrag 
[cdkDragDisabled]="setting!=true || resize==true" 
cdkDragBoundary=".example-boundary"
[style.width.px]="width" 
[style.top.px]="top" 
[style.left.px]="left" 
[style.minWidth.px]="minWidth" 
(cdkDragEnded)="dragEnd($event)" 
(cdkDragStarted)="dragStart($event)"
mwlResizable
[enableGhostResize]="true"
[resizeEdges]="{bottom : true}"
(resizeEnd)="onResizeEnd($event)"
style="border-bottom-left-radius: 10px; border-bottom-right-radius: 10px;">
  <div (mouseover)='intoDrag($event)'(mouseout)="outDrag($event)" cdkDragHandle class="card-header titre" >{{numTitle}}</div>
  {{errormsg}}
  <span class="d-flex flex-column justify-content-between position-absolute settings">
    <span class="d-flex flex-column "  *ngIf="type != 'number'">
      <button type="button" class="btn btn-sm " (click)="changeStyle('pie')" *ngIf="setting==true" [ngClass]="lineChartType == 'pie' ? 'btn-outline-success' : 'btn-outline-danger'">
        <i class="fa fa-pie-chart" aria-hidden="true"></i>
      </button> 
      <button type="button" class="btn btn-sm  btn-outline-success"  (click)="changeStyle('line')" *ngIf="setting==true" [ngClass]="lineChartType == 'line' ? 'btn-outline-success' : 'btn-outline-danger'">
        <i class="fa fa-line-chart" aria-hidden="true"></i>
      </button> 
      <button type="button" class="btn btn-sm  btn-outline-success" (click)="changeStyle('bar')" *ngIf="setting==true" [ngClass]="lineChartType == 'bar' ? 'btn-outline-success' : 'btn-outline-danger'">
        <i class="fa fa-bar-chart" aria-hidden="true"></i>
      </button> 
    </span>
      

      <button type="button" class="btn btn-sm btn-danger" (click)="setInactive(graph)" *ngIf="setting==true" [disabled]="load">
        <i class="fa fa-ban" aria-hidden="true"></i>
      </button> 
      
  </span>
      
      <canvas *ngIf='type == "graph"' baseChart 
          [datasets]="lineChartData" 
          [labels]="lineChartLabels" 
          [options]="lineChartOptions"
          [colors]="lineChartColors" 
          [legend]="lineChartLegend" 
          [chartType]="lineChartType"
          (mouseover)='intoDrag($event)'
          (mouseout)="outDrag($event)"
          cdkDragHandle >
      </canvas>
      <div *ngIf='type == "number"'  cdkDragHandle (mouseover)='intoDrag($event)'
      (mouseout)="outDrag($event)" class="d-flex flex-wrap justify-content-between">
        <div class="d-flex flex-column" >
          <div *ngFor="let item of showData" class="d-flex flex-column align-items-center">
            <h1 style="margin-top: 5%;" *ngIf="item.key =='Total'" class="total">{{item.value}} {{unite}}</h1>
          </div>
          <canvas *ngIf='gotData' baseChart 
            [datasets]="lineChartData" 
            [labels]="lineChartLabels" 
            [options]="lineChartOptions"
            [colors]="lineChartColors" 
            [legend]="lineChartLegend" 
            [chartType]="lineChartType"
            (mouseover)='intoDrag($event)'
            (mouseout)="outDrag($event)"
            [style.minWidth.px]="200" 
            [style.maxWidth.px]="900" 
            [style.Width.px]="width" 
            legendPosition = "bottom"
            cdkDragHandle >
          </canvas>
        </div>
      <div>
    </div> 
</div>
<div  *ngIf='type == "map"' >
  <canvas id="confirmedGeoCanvas" [style.minWidth.px]="200" 
  [style.maxWidth.px]="900" 
  [style.Width.px]="width"></canvas>
</div>